import { useMainStore } from "@/settings/zustand"
import Layouts from "."

export function menu(){
  return useMainStore.getState().layout?.routing
  //return Layouts().routing
}
